import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import moment from 'moment'

import latoBold from '../../../fonts/Lato-Bold.ttf'
import ladoRegular from '../../../fonts/Lato-Regular.ttf'

Font.register({
    family: 'Lato',
    fonts: [
        {
            src: ladoRegular
        },
        {
            src: latoBold,
            fontWeight: 'bold'
        }
    ]
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Lato',
        backgroundColor: 'white',
        fontSize: 10,
        padding: 30,
        marginTop: 20
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
    },
    header2: {
        marginTop: -15,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'start',
        alignContent: 'center',
    },
    infoCliente: {
        marginTop: 10
    },
    dato: {
        marginTop: 5,
        display: 'flex',
        flexDirection: 'row'
    },
    dato2: {
        marginTop: 8,
        display: 'flex',
        flexDirection: 'row'
    },
    referencia: {
        marginTop: 15,
        color: '#483B4C',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 9
    },
    table: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: 2,
        paddingTop: 2,
        paddingBottom: 2,
        borderBottomColor: '#8E24AA',
        fontWeight: '400',
        color: '#483B4C'
    },
    title: {
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#FAF9FA',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 10,
        fontWeight: '600',
        textTransform: 'uppercase'
    },
    item: {
        padding: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: '#78667E',
        fontStyle: 'normal',
        fontSize: 10,
        fontWeight: '400',
        textTransform: 'capitalize'
    },
    // pptoTitle: {
    //     color: '#8E24AA',
    //     fontFamily: 'Lato',
    //     fontWeight: 'bold',
    // },
    pptoTitle: {
        color: '#8E24AA',
        fontFamily: 'Lato',
        fontSize: 12,
        textTransform: 'uppercase'
    },
    labelNameFecha: {
        color: '#483B4C',
        marginTop: 5
    },
    labelNameNro: {
        color: '#483B4C',
        fontSize: 11,
        fontWeight: '600'
    },
    labelName: {
        color: '#483B4C',
        width: 80,
    },
    labelName2: {
        color: '#483B4C',
        width: 100,
    },
    labelValue: {
        color: '#78667E',
        fontSize: 9,
        textTransform: 'uppercase'
    },
    wrapTotales: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end'
    },
    totales: {
        marginTop: 10,
        padding: 5,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        backgroundColor: '#FAF9FA',
        fontStyle: 'normal',
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    labelNameTotal: {
        color: '#483B4C',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9
    },
    labelValueTotal: {
        color: '#483B4C',
        fontWeight: 400,
        width: 110,
        fontSize: 10,
        textAlign: 'right'
    },
    labelNameIGV: {
        color: '#78667E',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9,
        textTransform: 'none'
    },
    containerLogo: {
        position: 'absolute',
        top: '40px',
        right: '50px',
        padding: '5px',
        boxSizing: 'border-box',
        width: '110px',
        height: '110px'
    },
    imgLogo: {
        objectFit: 'contain',
        width: '100%',
        height: '100%'
    }
})

const formatNumber = (value = 0, currency = null) => {

    let country = {
        iso: 'en-US',
        currency: 'USD',
        decimales: 0
    }

    if (currency === 'S/') {
        country.iso = 'es-PE'
        country.currency = 'PEN'
        country.decimales = 2
    }

    const formatter = new Intl.NumberFormat(country.iso, {
        style: 'currency',
        currency: country.currency,
        maximumFractionDigits: country.decimales,
        minimumFractionDigits: country.decimales
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    })

    return formatter.format(value)

}

export const PdfFile = ({ auth, infoEmp, dataPreview, viewOptions, urlLogo, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                <View style={styles.header}>
                    <View>
                        {pdf_color_formato ?
                            <Text style={{
                                color: pdf_color_formato,
                                fontFamily: 'Lato',
                                fontSize: 12,
                                textTransform: 'uppercase',
                                fontWeight: 'Bold'
                            }}>
                                {dataPreview.tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}
                            </Text>
                            :
                            <Text style={styles.pptoTitle}>
                                {dataPreview.tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}
                            </Text>
                        }
                        {/* <Text style={styles.pptoTitle}>{dataPreview.tipo_gasto === 'os' ? 'ORDEN DE SERVICIO' : 'ORDEN DE COMPRA'}</Text> */}
                        <Text style={styles.labelNameNro}>{`#0000${dataPreview.numero}`}</Text>
                        <Text style={styles.labelNameFecha}>{moment(new Date()).format('DD MMMM YYYY')}</Text>
                    </View>
                </View>

                <View style={styles.containerLogo}>
                    <Image
                        style={styles.imgLogo}
                        src={urlLogo}
                        alt="logo"
                    />
                </View>

                <InfoCliente
                    auth={auth}
                    info={dataPreview}
                />

                <View style={styles.referencia}>
                    <Text style={{ textTransform: 'uppercase' }}>{dataPreview.referencia}</Text>
                </View>

                <Items
                    info={dataPreview}
                    viewOptions={viewOptions}
                    infoGeneral={infoGeneral}
                />

                <Totales
                    info={dataPreview}
                    viewOptions={viewOptions}
                />

                <Condiciones
                    info={dataPreview}
                    infoGeneral={infoGeneral}
                />

                <DatosEmpresa
                    info={infoEmp}
                    infoGeneral={infoGeneral}
                />

            </Page>
        </Document >
    )
}

const Items = ({ info, viewOptions, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <>

            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA' }]}>
                <Text style={{ width: 200, textAlign: 'left' }}>Ítems</Text>
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Cant.</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Días</Text>
                }
                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>P. Unitario</Text>
                }
                {!viewOptions.ocultar_montos_items &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Subtotal</Text>
                }
            </View>

            {info?.items?.map((title, index) => {
                return (
                    <>
                        <View style={styles.title}>
                            <Text style={{ width: 200, textAlign: 'left' }}>{title.nombre}</Text>
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                <Text style={{ width: 100, textAlign: 'center' }}>{title.cantidad}</Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                <Text style={{ width: 100, textAlign: 'center' }}>{title.dias}</Text>
                            }
                            {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.precio_unitario, info.simbolo)}
                                </Text>
                            }
                            {!viewOptions.ocultar_montos_items &&
                                <Text style={{ width: 100, textAlign: 'right' }}>
                                    {formatNumber(title.subtotal, info.simbolo)}
                                </Text>
                            }
                        </View>
                        {!viewOptions.ver_solo_titulos && title.items?.map((item, index2) => (
                            <View style={styles.item}>
                                <Text style={{ width: 200, textAlign: 'left' }}>
                                    <Text style={{ marginLeft: 50 }}>{"  "}{index2 + 1}.</Text>
                                    <Text style={{ marginLeft: 100 }}>{"  "}{item.nombre}</Text>
                                </Text>
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                    <Text style={{ width: 100, textAlign: 'center' }}>{item.cantidad}</Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                    <Text style={{ width: 100, textAlign: 'center' }}>{item.dias}</Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_item) &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {formatNumber(item.precio_unitario, info.simbolo)}
                                    </Text>
                                }
                                {!viewOptions.ocultar_montos_items &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {formatNumber(item.subtotal, info.simbolo)}
                                    </Text>
                                }
                            </View>
                        ))}
                    </>
                )
            })}

        </>
    )
}

const InfoCliente = ({ auth, info }) => {
    return (
        <>
            <View style={styles.infoCliente}>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Proveedor:</Text>
                    <Text style={styles.labelValue}>{info?.razon_social || 'N/A'}</Text>
                </View>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>RUC:</Text>
                    <Text style={styles.labelValue}>{info?.ruc || 'N/A'}</Text>
                </View>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Documento:</Text>
                    <Text style={styles.labelValue}>{info?.docName || 'N/A'}</Text>
                </View>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Enviado por:</Text>
                    <Text style={styles.labelValue}>{`${auth.name || 'Nombre'} / ${auth.email || 'N/A'}`}</Text>
                </View>
            </View>
        </>
    )
}

const Totales = ({ info }) => {
    return (
        <View style={styles.wrapTotales}>
            <View style={{ width: '58%' }}></View>
            <View style={[styles.totales, { width: '42%' }]}>

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>SUBTOTAL</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.subtotal}
                        </Text>
                    </View>
                }

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>( {info.descuento_porcentaje}% )  DESC</Text>
                        <Text style={styles.labelValueTotal}>
                            {info.simbolo}{' '}{info.descuento}
                        </Text>
                    </View>
                }

                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>TOTAL BASE</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.monto_base, info.simbolo)}
                    </Text>
                </View>

                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>( {parseFloat(info.impuesto_porcentaje).toFixed(0)}% )  IGV</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.total_impuesto, info.simbolo)}
                    </Text>
                </View>
                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal}>TOTAL</Text>
                    <Text style={styles.labelValueTotal}>
                        {formatNumber(info.total_compra, info.simbolo)}
                    </Text>
                </View>

            </View>
        </View>
    )
}

const Condiciones = ({ info, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <>
            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA', marginBottom: 10 }]}>
                <Text>CONDICIONES</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Forma de pago:</Text>
                <Text style={styles.labelValue}>{info.payFormsName || ''}</Text>
            </View>
            {info.observaciones &&
                <View style={styles.dato}>
                    <Text style={styles.labelName2}>Observaciones:</Text>
                    <Text style={styles.labelValue}>{info.observaciones || 'N/A'}</Text>
                </View>
            }
        </>
    )
}

const DatosEmpresa = ({ info, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <>
            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA', marginBottom: 10 }]}>
                <Text>DATOS DE FACTURACIÓN</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Razón social:</Text>
                <Text style={styles.labelValue}>{info.razon_social}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>RUC:</Text>
                <Text style={styles.labelValue}>{info.ruc}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Dirección:</Text>
                <Text style={styles.labelValue}>{info.direccion}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Teléfono:</Text>
                <Text style={styles.labelValue}>{info.fono}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Página web:</Text>
                <Text style={[styles.labelValue, { textTransform: 'lowercase' }]}>{info.sitio_web}</Text>
            </View>
        </>
    )
}